import axios from "axios";

const DEFAULT_API = "http://localhost:8080";
const envUrl = process.env.REACT_APP_API_URL;

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// If not on localhost, use the current origin (server domain)
let API_URL = envUrl && envUrl.trim() !== "" ? envUrl : DEFAULT_API;

if (!isLocalhost) {
  API_URL = window.location.origin;
} else if (API_URL.includes("tahashoes.vn")) {
  console.log("🛠️ Localhost detected, falling back to local API");
  API_URL = DEFAULT_API;
}

export { API_URL };
console.log("🌐 API Base URL:", API_URL);

/**
 * Helper to get full image URL, handle both external and local uploads
 */
export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (imagePath.startsWith("http") || imagePath.startsWith("data:") || imagePath.startsWith("blob:")) {
    return imagePath;
  }
  // Ensure we don't have double slashes
  const path = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;
  return `${API_URL}${path}`;
};


const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      if (token && !config.headers?.Authorization) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
    }
    return Promise.reject(err);
  }
);

export const productAPI = {
  getAll: (params) => api.get("/products", { params }),
  getById: (id) => api.get(`/products/${id}`),
  getBySlug: (slug) => api.get(`/products/slug/${slug}`),
  getRelated: (id) => api.get(`/products/${id}/related`),
  create: (data) => api.post("/products", data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

export default api;
